import { createSlice } from '@reduxjs/toolkit';
import { selectNone, SortTypeEnum, } from '../../../consts/CommonConsts';
import { sortJobListEnum } from '../../../consts/UserConst';
const initialState = {
    ranks: [],
    locals: [],
    unit_price: selectNone,
    industries: [],
    construction_periods: [],
    sort: {
        type: SortTypeEnum.Desc,
        kind: sortJobListEnum.Latest
    },
    searchedCheck: false
};
const jobSearchSlice = createSlice({
    name: 'userJobinfoSearch',
    initialState,
    reducers: {
        setSearchAction(state, action) {
            return state = action.payload;
        },
    },
});
//Actions
export const { setSearchAction, } = jobSearchSlice.actions;
export default jobSearchSlice;
